import React, {Component} from 'react'
import PropTypes from 'prop-types'
import EditMark from './EditMark'
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'
import { connect } from 'react-redux'
import moment from 'moment'
import MarkRequest from '../MarkRequest/MarkRequest'

class EditMarkContainer extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.state = {
      mark: {},
      user: {},
      settings: [],
      markRules: {},
      initialValues: {},
      selectedDocuments: [],
      loading: true,
      price: null,
      errors: null,
      vehicleOwnershipTypes: [],
      vehiclePowerSupplies: [],
      documentTypes: [],
      submitting: false
    }

    this.onVehicleSelected = this.onVehicleSelected.bind(this)
    this.onVehicleAdd = this.onVehicleAdd.bind(this)
    this.onVehicleRemove = this.onVehicleRemove.bind(this)
    this.onVehicleOwnershipTypeChange = this.onVehicleOwnershipTypeChange.bind(this)
    this.onVehiclePowerSupplyChange = this.onVehiclePowerSupplyChange.bind(this)
    this.onDocumentAdd = this.onDocumentAdd.bind(this)
    this.onDocumentRemove = this.onDocumentRemove.bind(this)
    this.onDocumentChange = this.onDocumentChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  async fetchInitialData () {
    this.setState({loading: true})
    const userResponse = await SostaOnlineApiService.fetchUserMe()
    const markResponse = await SostaOnlineApiService.fetchMarkMe(this.props.match.params.id)

    if (markResponse.data.status !== 'ACTIVE_EDITABLE' && markResponse.data.status !== 'PENDING_EDITABLE') {
      this.setState({
        loading: false,
        errors: 'Errore! Questo contrassegno non è modificabile al momento'
      })
      return
    }

    const rules = await SostaOnlineApiService.fetchMarkRulesByMarkType(markResponse.data.MarkType.id)
    const settingsResponse = await SostaOnlineApiService.fetchPublicSettings()
    const vehicleOwnershipTypes = await SostaOnlineApiService.fetchVehicleOwnershipTypes()
    const vehiclePowerSupplies = await SostaOnlineApiService.fetchVehiclePowerSupplies()
    const documentsTypes = await SostaOnlineApiService.fetchDocumentTypesByMarkTypeId(markResponse.data.MarkType.id)

    let initialValues = {}

    for (let index in markResponse.data.Vehicles) {
      initialValues['vehicle' + index] = markResponse.data.Vehicles[index]
      initialValues['powerSupply' + index] = markResponse.data.Vehicles[index].VehiclePowerSupplyId + ''
      initialValues['ownershipType' + index] = markResponse.data.Vehicles[index].VehicleOwnershipTypeId + ''
    }

    for (let index in markResponse.data.MarkDocuments) {
      initialValues['documentFile-' + index] = {
        ...markResponse.data.MarkDocuments[index].Document,
        approved: markResponse.data.MarkDocuments[index].approved
      }
    }

    /* for (let dI = 0; dI < documentsTypes.data.length; dI++) {
      const documentType = documentsTypes.data[dI]

      if (documentType.slug === 'carta_circolazione_veicoli') {
        for (let vI = 0; vI < markResponse.data.Vehicles.length; vI++) {
          const vehicle = markResponse.data.Vehicles[vI]
          initialValues['documentFile-' + vehicle.plate_number.toLowerCase()] = {
            ...vehicle.VehicleDocuments[0].Document,
            approved: vehicle.VehicleDocuments[0].approved
          }
        }
      } else {
        initialValues['documentFile-' + documentType.id] = {
          ...markResponse.data.MarkDocuments.filter(item => item.DocumentTypeId === documentType.id)[0].Document,
          approved: markResponse.data.MarkDocuments.filter(item => item.DocumentTypeId === documentType.id)[0].approved
        }
      }
    } */

    this.setState({
      user: userResponse.data,
      mark: markResponse.data,
      markRules: rules.data[0],
      documentTypes: documentsTypes.data.map(item => {
        return {
          documentTypeId: item.id,
          slug: item.slug,
          typeName: item.name,
          vehiclePlateNumber: null,
          document: null
        }
      }),
      settings: settingsResponse.data,
      vehicleOwnershipTypes: vehicleOwnershipTypes.data,
      vehiclePowerSupplies: vehiclePowerSupplies.data,
      loading: false,
      initialValues: initialValues,
      selectedDocuments: markResponse.data.MarkDocuments.map(item => ({...item.Document, DocumentType: item.DocumentType}))
    }, async () => this.updatePrice())
    console.log()
  }

  getSettingByName (name) {
    const { settings } = this.state
    const foundSettings = settings.filter(item => item.name === name)
    if (foundSettings.length === 0) {
      return null
    }

    return foundSettings[0]
  }

  async componentDidMount () {
    await this.fetchInitialData()
  }

  getUserMarksByTypeId (markType) {
    const today = moment()
    return this.state.user.marks.filter(item => {
      const endDate = moment(item.endDate)
      const isExpired = today.diff(endDate, 'days') > 0
      return item.markTypeId === markType.id && !item.ceased && item.active && !item.ceased && !isExpired
    })
  }

  printVehiclesPowerSupplies (vehicles) {
    let string = ''
    vehicles.map((item, index) => {
      string = string + item.VehiclePowerSupply.id

      if (index < vehicles.length - 1) {
        string = string + ','
      }
    })
    return string
  }

  async updatePrice () {
    this.setState({errors: null})
    try {
      const matchingCategories = [this.state.mark.Category]
      let promises = matchingCategories.map((item) => {
        const p = SostaOnlineApiService.fetchMarkPrice(
          this.state.user.id,
          this.state.mark.MarkType.id,
          item.id,
          null,
          this.printVehiclesPowerSupplies(this.state.mark.Vehicles)
        )
        return p
      })

      const prices = await Promise.all(promises)
      if (prices.filter(item => item.result !== 'ok').length > 0) {
        this.setState({errors: 'errore durante la ricezione dei prezzi'})
      }

      let lowestPrice = prices[0].data
      prices.map(item => {
        if (item.data.price < lowestPrice) {
          lowestPrice = item.data
        }
      })

      this.setState({price: lowestPrice})
    } catch (ex) {
      this.setState({errors: 'Errore durante l\'elaborazione dei prezzi'})
    }
  }

  onVehicleSelected (vehicle, index) {
    let newVehicles = [...this.state.mark.Vehicles]
    newVehicles[index] = vehicle
    this.setState({
      mark: {
        ...this.state.mark,
        Vehicles: newVehicles
      },
      initialValues: {
        ...this.state.initialValues,
        [`powerSupply${index}`]: vehicle.type !== 'new' ? vehicle.VehiclePowerSupplyId + '' : null,
        [`ownershipType${index}`]: vehicle.type !== 'new' ? vehicle.VehicleOwnershipTypeId + '' : null
      }
    }, async () => {
      if (vehicle.type !== 'new') {
        await this.updatePrice()
      }
    })
  }

  onVehicleRemove (index) {
    this.setState({
      mark: {
        ...this.state.mark,
        Vehicles: this.state.mark.Vehicles.filter((_, i) => i !== index)
      }
    }, async () => {
      if (this.state.mark.Vehicles.length > 0) {
        await this.updatePrice()
      } else {
        this.setState({price: null})
      }
    })
  }

  onVehicleAdd () {
    if (this.state.markRules.vehicleLimit === this.state.mark.Vehicles.length) {
      return
    }

    this.setState({
      mark: {
        ...this.state.mark,
        Vehicles: [...this.state.mark.Vehicles, {}]
      }
    })
  }

  onVehicleOwnershipTypeChange (e, index) {
    let newVehicles = [...this.state.mark.Vehicles]
    newVehicles[index].VehicleOwnershipType = {id: e.target.value}
    this.setState({
      mark: {
        ...this.state.mark,
        Vehicles: newVehicles
      }
    }, () => this.updatePrice())
  }

  onVehiclePowerSupplyChange (e, index) {
    let newVehicles = [...this.state.mark.Vehicles]
    newVehicles[index].VehiclePowerSupply = {id: e.target.value}
    this.setState({
      mark: {
        ...this.state.mark,
        Vehicles: newVehicles
      }
    }, () => this.updatePrice())
  }

  onDocumentChange (document, index) {
    const {selectedDocuments} = this.state
    const newDocuments = selectedDocuments.map((item, i) => {
      if (i === index) {
        return document
      } else {
        return item
      }
    })
    this.setState({selectedDocuments: newDocuments})
  }

  onDocumentRemove (index) {
    this.setState({selectedDocuments: this.state.selectedDocuments.filter((_, i) => i !== index)})
  }

  onDocumentAdd () {
    this.setState({selectedDocuments: [...this.state.selectedDocuments, {}]})
  }

  async onSubmit (values) {
    const { submitting, mark, selectedDocuments } = this.state

    if (submitting) {
      return
    }

    try {
      this.setState({submitting: true, errors: null})

      // const uploadingDocuments = {}
      if (mark.status === 'PENDING_EDITABLE') {

        // validiamo i documenti, se ne manca qualcuno ritorniamo errore
        /* for (let i = 0; i < documentTypes.length; i++) {
          const document = documentTypes[i]
          if (document.slug === 'carta_circolazione_veicoli') {
            for (let iV = 0; iV < mark.Vehicles.length; iV++) {
              const vehicle = mark.Vehicles[iV]
              if (!values['documentFile-' + vehicle.plate_number.toLowerCase()]) {
                this.setState({
                  errors:
                  'Il documento: ' + document.typeName + ' per il veicolo: ' + vehicle.plate_number + ' è obbligatorio.'
                })
                continue
              } else if (!values['documentFile-' + vehicle.plate_number.toLowerCase()].id.approved) {
                uploadingDocuments[vehicle.plate_number.toLowerCase()] = {}
                uploadingDocuments[vehicle.plate_number.toLowerCase()][document.documentTypeId] =
                  values['documentFile-' + vehicle.plate_number.toLowerCase()].id
              }
            }
          } else {
            if (!values['documentFile-' + document.documentTypeId]) {
              this.setState({
                errors: 'Il documento: ' + document.typeName + ' è obbligatorio.'
              })
              continue
            } else if (!values['documentFile-' + document.documentTypeId].approved) {
              uploadingDocuments[document.documentTypeId] = values['documentFile-' + document.documentTypeId].id
            }
          }
        } */
      }

    console.log(selectedDocuments)
      const response = await SostaOnlineApiService.updateMarkMe({
        id: mark.id,
        vehicles: mark.Vehicles,
        documents: selectedDocuments.map(item => item.id)
      })
      if (response.result !== 'ok') {
        this.setState({
          errors: 'Errore durante la richiesta di modifica del contrassegno',
          submitting: false
        })
      } else {
        this.setState({
          submitting: false
        })
        this.props.history.push('/user-area/marks')
      }
    } catch (e) {
      console.error(e)
      this.setState({submitting: false})
    }
  }

  render () {
    const {
      mark,
      loading,
      errors,
      user,
      vehicleOwnershipTypes,
      vehiclePowerSupplies,
      markRules,
      price,
      submitting,
      initialValues,
      documentTypes,
      selectedDocuments
    } = this.state

    return (
      <EditMark
        mark={mark}
        user={user}
        initialValues={initialValues}
        markExpirationDate={this.getSettingByName('MarkExpirationDate_' + mark.markTypeId)}
        errors={errors}
        onVehicleSelected={this.onVehicleSelected}
        vehicleOwnershipTypes={vehicleOwnershipTypes}
        vehiclePowerSupplies={vehiclePowerSupplies}
        loading={loading}
        onVehicleAdd={this.onVehicleAdd}
        onVehicleRemove={this.onVehicleRemove}
        onVehiclePowerSupplyChange={this.onVehiclePowerSupplyChange}
        onVehiclePropertyTypeChange={this.onVehicleOwnershipTypeChange}
        price={price}
        documents={documentTypes}
        onSubmit={this.onSubmit}
        markRules={markRules}
        submitting={submitting}
        selectedDocuments={selectedDocuments}
        onDocumentAdd={this.onDocumentAdd}
        onDocumentRemove={this.onDocumentRemove}
        onDocumentChange={this.onDocumentChange}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth
})

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(EditMarkContainer)



// WEBPACK FOOTER //
// ./src/containers/UserArea/EditMark/EditMarkContainer.js